import { render, staticRenderFns } from "./WarehouseOrders.vue?vue&type=template&id=4eb08019&"
import script from "./WarehouseOrders.vue?vue&type=script&lang=js&"
export * from "./WarehouseOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports